module.exports = __webpack_public_path__ + "efd57e.pdf";